import { useEffect } from "react";

// Automaat.online planningsmodule — klant Automobielbedrijf Stoof
const CSW_CDKEY = "CSW-7054060";
const CSW_SERVER = "srv5";
const CSW_DESIGN = ""; // leeg | small | motor

export const PlanningModule = ({ className = "" }) => {
  useEffect(() => {
    window.cswParams = { cdkey: CSW_CDKEY, adminId: 0, design: CSW_DESIGN };

    // FIX voor bug in de externe module: hun e-mailregex staat alleen TLD's van
    // 2-3 tekens toe (.info/.email etc. worden onterecht geweigerd). We overrulen
    // uitsluitend die specifieke defecte regex met een correcte e-mailcheck.
    const origTest = RegExp.prototype.test;
    // eslint-disable-next-line no-extend-native
    RegExp.prototype.test = function (str) {
      try {
        if (typeof this.source === "string" && this.source.includes("@") && this.source.includes("(\\.\\w{2,3})+")) {
          return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(str));
        }
      } catch (e) { /* val terug op origineel */ }
      return origTest.call(this, str);
    };
    const restoreTest = () => {
      if (RegExp.prototype.test !== origTest) RegExp.prototype.test = origTest;
    };

    let userScrolled = false;
    const markScrolled = () => { userScrolled = true; };
    window.addEventListener("wheel", markScrolled, { passive: true });
    window.addEventListener("touchmove", markScrolled, { passive: true });
    window.addEventListener("keydown", markScrolled, { passive: true });

    // Kernoorzaak: het externe script roept .focus() aan op een veld, waardoor de
    // browser naar de module scrollt. Tijdens het laadvenster forceren we
    // preventScroll op elke focus-aanroep, zodat er geen scroll-sprong optreedt.
    const origFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (opts) {
      return origFocus.call(this, { ...(opts || {}), preventScroll: true });
    };
    const restoreFocus = () => {
      if (HTMLElement.prototype.focus !== origFocus) HTMLElement.prototype.focus = origFocus;
    };

    const resetTop = () => {
      if (userScrolled) return;
      const lenis = window.__stoofLenis;
      if (lenis) lenis.scrollTo(0, { immediate: true, force: true });
      else window.scrollTo(0, 0);
    };

    // Vangnet: mocht er toch focus binnen de module vallen, corrigeer de scroll.
    const holder = document.getElementById("cswPlanningHolder");
    const onFocusIn = (e) => {
      if (!userScrolled && holder && holder.contains(e.target)) requestAnimationFrame(resetTop);
    };
    document.addEventListener("focusin", onFocusIn, true);

    const script = document.createElement("script");
    script.src = `https://${CSW_SERVER}.automaat.online/planning/script.js`;
    script.async = true;
    script.setAttribute("data-csw-planning", "1");
    document.body.appendChild(script);

    // Extra correcties gedurende het volledige laadvenster (de focus valt soms pas na ~3s).
    const timers = [200, 600, 1200, 2000, 3000, 4000, 5500, 7000].map((t) => setTimeout(resetTop, t));
    const stop = setTimeout(() => {
      restoreFocus();
      document.removeEventListener("focusin", onFocusIn, true);
    }, 8000);

    return () => {
      timers.forEach(clearTimeout);
      clearTimeout(stop);
      restoreFocus();
      restoreTest();
      document.removeEventListener("focusin", onFocusIn, true);
      window.removeEventListener("wheel", markScrolled);
      window.removeEventListener("touchmove", markScrolled);
      window.removeEventListener("keydown", markScrolled);
      script.remove();
      const h = document.getElementById("cswPlanningHolder");
      if (h) h.innerHTML = "";
    };
  }, []);

  return (
    <div className={`csw-planning ${className}`} data-testid="planning-module">
      {/* De externe module rendert in deze holder */}
      <div id="cswPlanningHolder" />
      <noscript>U dient JavaScript te hebben ingeschakeld om de planmodule te gebruiken.</noscript>
    </div>
  );
};
